<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <v-card>
      <v-toolbar flat dense class="primary primaryText--text">
        <v-flex md11>
          <v-toolbar-title>Download Report</v-toolbar-title>
        </v-flex>
        <v-flex md1 class="text-xs-right">
          <v-btn icon @click="resetDownload">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-toolbar>
      <v-card-text class="pa-0 primary">
        <v-container fluid grid-list-xl>
          <p class="infoDevice">** Maximum number of devices: {{ noOfDeviceAllowed }}</p>
          <h4 class="font-weight-thin sub-title">Select Device</h4>

          <v-select :items="tab" :rules="[deviceValidation || `Device must be less than ${noOfDeviceAllowed}`]" v-model="chipItems" label="Select Item" item-text="name" item-value="modifiedId"
            color="orange" outline multiple required>
            <template slot="prepend-item">
              <v-list-tile ripple @click="toggleSecond">
                <v-list-tile-action>
                  <v-icon color="indigo darken-4">mdi-checkbox-blank-outline</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-if="chipItems.length == 0">Select All</v-list-tile-title>
                  <v-list-tile-title v-else-if="chipItems.length == tab.length">Deselect All</v-list-tile-title>
                  <v-list-tile-title v-else>Select All</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider class="mt-2"></v-divider>
            </template>

            <template slot="selection" slot-scope="{ item, index }">
              <span v-if="index === 0">
                {{ item }}
              </span>
              <span v-if="index === 1" class="grey--text caption">(+{{ chipItems.length - 1 }} others)</span>
            </template>
          </v-select>

          <v-divider class="divider"></v-divider>
        </v-container>
      </v-card-text>
      <div class="action-btn__center primary">
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="dialog = false; initiateDownload()" :disabled="disable">
          Download
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from '@/services/event-bus'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  mounted() {
    EventBus.$on('open:downloadDialog', this.openDialog)
  },
  beforeDestroy() {
    EventBus.$off('open:downloadDialog', this.openDialog)
  },
  computed: {
    ...mapGetters('report', ['selectedRange', 'dateFrom', 'dateTo']),
    deviceValidation() {
      if (moment(this.dateFrom).isSame(this.dateTo, 'day')) {
        return this.chipItems.length <= 10
      } else {
        return this.chipItems.length <= 5
      }
    },
    noOfDeviceAllowed() {
      if (moment(this.dateFrom).isSame(this.dateTo, 'day')) {
        return 10
      } else {
        return 5
      }
    },
    icon() {
      return 'mdi-checkbox-blank-outline'
    },
    disable() {
      if (moment(this.dateFrom).isSame(this.dateTo, 'day')) {
        return this.chipItems.length > 10 || this.chipItems.length == 0
      } else {
        return this.chipItems.length > 5 || this.chipItems.length == 0
      }
    },
    selectAll() {
      return this.chipItems.length === this.tab.length
    }
  },
  data() {
    return {
      dialog: false,
      tab: [],
      chipItems: []
    }
  },
  methods: {
    resetDownload() {
      this.dialog = false
      this.chipItems = []
    },
    openDialog(val) {
      this.dialog = true
      this.tab = val
    },
    initiateDownload() {
      EventBus.$emit('download:immediateReport', this.chipItems)
      this.chipItems = []
    },
    toggleSecond() {
      this.$nextTick(() => {
        if (this.selectAll) {
          this.chipItems = []
        } else {
          this.chipItems = this.tab.map(item => item)
        }
      })
    }
  }
}
</script>

<style scoped>
  .infoDevice {
    color: #fbbc05;
  }
  .action-btn__center {
    text-align: center;
    padding-bottom: 0.5rem;
  }

</style>